const TEAM_CANONICAL_ORIGIN = 'https://team.ftedn.com';

export function canonicalTeamUrlFor(location: Location): string | null {
  if (location.protocol !== 'https:') return null;
  if (!location.hostname.endsWith('.run.app')) return null;
  if (!location.hostname.startsWith('ftedn-team-app-')) return null;

  return `${TEAM_CANONICAL_ORIGIN}${location.pathname}${location.search}${location.hash}`;
}

export function redirectCloudRunTeamOrigin(location: Location = window.location): void {
  const canonicalUrl = canonicalTeamUrlFor(location);
  if (!canonicalUrl) return;

  location.replace(canonicalUrl);
}
